import React, { useState, useRef } from "react"
import { useTranslation } from "next-i18next"

import ProductOptionSelectorUI from "@/components/MultiFinshProductBundle/ui/ProductOptionSelectorUI"
import { getTranslations } from "@/components/Bundles/localization"

const ProductOptionSelector = props => {
  const { authoredData = {}, config = {} } = props || {}
  const prevButtonRef = useRef(null)
  const nextButtonRef = useRef(null)

  const [isPrevVisible, setIsPrevVisible] = useState(false)
  const [isNextVisible, setIsNextVisible] = useState(false)
  const [isAllSlidesVisible, setIsAllSlidesVisible] = useState(false)

  const { t } = useTranslation("common")
  const staticTexts = getTranslations(t)

  const { general: { swatchUrl = "", scene7AccountName = "PAWEB" } = {} } =
    config || {}

  const { presetConfigs = "{}" } = authoredData

  // To update the visibility of the next and previous buttons based on the current slide position
  const updateButtonVisibility = swiper => {
    const slideWidth = swiper.slides[0]?.offsetWidth || 0
    const slidesCount = swiper.slides.length
    let spaceBetween = swiper.params.spaceBetween

    if (typeof spaceBetween === "string" && spaceBetween.endsWith("px")) {
      spaceBetween = parseInt(spaceBetween, 10)
    } else {
      spaceBetween = Number(spaceBetween) || 0
    }

    const totalSlidesWidth =
      slideWidth * slidesCount + spaceBetween * (slidesCount - 1)

    const allSlidesVisible = totalSlidesWidth <= swiper.width
    setIsAllSlidesVisible(allSlidesVisible)

    if (allSlidesVisible) {
      setIsPrevVisible(false)
      setIsNextVisible(false)
    } else {
      setIsPrevVisible(!swiper.isBeginning)
      setIsNextVisible(!swiper.isEnd)
    }
  }

  return (
    <div className="product-option-selector">
      <ProductOptionSelectorUI
        {...props}
        prevButtonRef={prevButtonRef}
        nextButtonRef={nextButtonRef}
        isPrevVisible={isPrevVisible}
        isNextVisible={isNextVisible}
        setIsNextVisible={setIsNextVisible}
        setIsPrevVisible={setIsPrevVisible}
        isAllSlidesVisible={isAllSlidesVisible}
        updateButtonVisibility={updateButtonVisibility}
        staticTexts={staticTexts}
        presetConfigObject={JSON.parse(presetConfigs)}
        assetAccountName={scene7AccountName}
        swatchUrl={swatchUrl}
      />
    </div>
  )
}

export default ProductOptionSelector
